import useSWR from "swr";
import { fetcher, blobFetcher } from "../config/axiosConfig.ts";
import { BaseUrl, swrOptions } from "../const.ts";
import { ITicketId } from "../model.ts";

// Fetch ticket details using SWR
export function useMyOrdersTicketId(id: string) {
  return useSWR<{ code: number; message: string; body: ITicketId[] }>(
      `${BaseUrl}/event-order-ms/ticket/my-orders/${id}`,
      fetcher,
      swrOptions
  );
}

export function useMyTicketsDownload() {
  const onSubmit = async (id: string) => {
    try {
      const response = await blobFetcher(`${BaseUrl}/event-order-ms/ticket/download/${id}`);

      if (!response || response.size === 0) {
        throw new Error("Failed to retrieve PDF data or PDF is empty.");
      }

      const blob = new Blob([response], { type: "application/pdf" });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = `ticket_${id}.pdf`; // Set the filename
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl); // Clean up the URL object
    } catch (error) {
      console.error("Error downloading the PDF:", error);
    }
  };

  return { onSubmit };
}
